import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import AuthenticatedPage from '../common/AuthenticatedPage.jsx';
import ValidatedComponent from '../common/ValidatedComponent.jsx';
import InputValidator from '../common/InputValidator.jsx';
import Loading from '../common/Loading.jsx';
import ImageEditor from '../common/ImageEditor.jsx';
import UserUtils from '../utils/UserUtils';
import * as Actions from './redux/actions';
import {bindActionCreators} from 'redux';
import ShareUtils from '../utils/ShareUtils';
import settings from '../../../config/settings';
import _ from 'lodash';

class ProfileInfo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showEmail: false,
      email: ''
    };

    this.onSaveClick = this.onSaveClick.bind(this);
    this.onShareClick = this.onShareClick.bind(this);
    this.showEmail = this.showEmail.bind(this);
    this.getTwitterShareUrl = this.getTwitterShareUrl.bind(this);
    this.getFbShareUrl = this.getFbShareUrl.bind(this);
    this.getGooglePlusShareUrl = this.getGooglePlusShareUrl.bind(this);
    this.getLinkedinShareUrl = this.getLinkedinShareUrl.bind(this);
  }

  componentDidMount() {
    this.props.initProfileEdit();
    this.refLink = _.get(settings, 'appBaseURL') + '/signup?referral_code=' + this.props.profile.referralCode;
  }

  onSaveClick() {
    const {profileEdit, saveProfile} = this.props;

    if (this.context.isComponentValid()) {
      saveProfile(profileEdit.id, profileEdit);
    }
  }

  onChange(propName, e) {
    this.state[propName] = e.target.value;
    this.setState(this.state);
  }

  showEmail() {
    this.setState({showEmail: !this.state.showEmail});
  }

  render() {
    const {showEmail} = this.state;
    const {
      profile, profileEdit, updateProfile, isEditMode, isFetching, isSaving, toggleProfileEdit
    } = this.props;

    let content;
    if (isEditMode) {
      content = (
        <div className="ba-profile-panel">
          <div className="row">
            <div className="small-12 columns ba-profile-header">
              <button className="button ba-default-btn right"
                      type="button"
                      onClick={this.onSaveClick}>
                Save Profile
              </button>
              <button type="button"
                      onClick={() => toggleProfileEdit()}
                      className="button ba-default-btn right alert">
                Cancel
              </button>
            </div>
          </div>
          <div className="row">
            <div className="small-12 medium-4 columns">
              <ImageEditor src={profileEdit.avatar ? profileEdit.avatar.fullSize : null}
                           fallbackImage={UserUtils.getAvatarUploadPlaceholderUrl()}
                           onReset={() => updateProfile({avatarUpload: null, avatar: null})}
                           onCropComplete={e => updateProfile({avatarUpload: e.blob})}/>
            </div>
            <div className="small-12 medium-8 columns">
              <div className="ba-profile-field-input">
                <input type="text"
                       value={profileEdit.firstName}
                       onChange={e => updateProfile({firstName: e.target.value})}
                       placeholder="First name*"/>
              </div>
              <div className="ba-profile-field-input">
                <input type="text"
                       value={profileEdit.lastName}
                       onChange={e => updateProfile({lastName: e.target.value})}
                       placeholder="Last name*"/>
              </div>
              <div className="ba-profile-field-input">
                <span className="email fa fa-envelope ba-profile-icon-display" />
                <input type="text"
                       value={profileEdit.email}
                       disabled
                       placeholder="Email*"/>
              </div>
              <div className="ba-profile-field-input">
                <span className="email fa fa-link ba-profile-icon-display" />
                <input type="text"
                       value={profileEdit.website}
                       placeholder="Website"/>
              </div>
              <div className="ba-profile-field-input">
                <span className="facebook fa fa-facebook-official ba-profile-icon-display" />
                <input type="text"
                       value={profileEdit.facebook}
                       placeholder="Facebook"/>
              </div>
              <div className="ba-profile-field-input">
                <span className="instagram fa fa-instagram ba-profile-icon-display" />
                <input type="text"
                       value={profileEdit.instagram}
                       placeholder="Instagram"/>
              </div>
              <div className="ba-profile-field-input">
                <span className="linkedin fa fa-linkedin-square ba-profile-icon-display" />
                <input type="text"
                       value={profileEdit.linkedin}
                       placeholder="LinkedIn"/>
              </div>
              <div className="ba-profile-field-input">
                <span className="twitter fa fa-twitter ba-profile-icon-display" />
                <input type="text"
                       value={profileEdit.twitter}
                       placeholder="Twitter"/>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      content = (
        <div className="ba-profile-panel">
          <div className="row">
            <div className="small-12 columns">
              <button type="button"
                      onClick={() => toggleProfileEdit()}
                      className="button ba-default-btn right">
                <span className="fa fa-cog" /> Edit Profile
              </button>
            </div>
          </div>
          <div className="row">
            <div className="small-12 medium-4 columns">
              <img className="ba-profile-info-avatar"
                   src={UserUtils.getImageUrl(profile)}/>
            </div>
            <div className="small-12 medium-8 columns">
              <div className="ba-profile-field-readonly">
                {profile.firstName}
              </div>
              <div className="ba-profile-field-readonly">
                {profile.lastName}
              </div>
              <div className="ba-profile-field-readonly">
                <span className="email fa fa-envelope ba-profile-icon-display" />
                {profile.email}
              </div>
              <div className="ba-profile-field-readonly">
                <span className="email fa fa-link ba-profile-icon-display" />
                {profile.website}
              </div>
              <div className="ba-profile-field-readonly">
                <span className="facebook fa fa-facebook-official ba-profile-icon-display" />
                {profile.facebook}
              </div>
              <div className="ba-profile-field-readonly">
                <span className="instagram fa fa-instagram ba-profile-icon-display" />
                {profile.instagram}
              </div>
              <div className="ba-profile-field-readonly">
                <span className="linkedin fa fa-linkedin-square ba-profile-icon-display" />
                {profile.linkedin}
              </div>
              <div className="ba-profile-field-readonly">
                <span className="twitter fa fa-twitter ba-profile-icon-display" />
                {profile.twitter}
              </div>


              <div className="referral">
                <div className="ba-profile-field-readonly-referral">
                  <div className="referral-title">
                    <span className="referral fa fa-users ba-profile-icon-display" /> Referral Code
                    <button className="referral-btn-copy">
                      copy code
                    </button>
                  </div>
                  <div>
                    <div className="referral-link">{this.refLink}</div>
                  </div>

                  <div className="referral-share">
                    <span className="referral-fieldname">share:</span>
                    {showEmail ?
                      <button onClick={this.showEmail}
                              className="ba-default-btn referral-btn referral-email fa fa-envelope-open" />
                      :
                      <button onClick={this.showEmail}
                              className="ba-default-btn referral-btn referral-email fa fa-envelope" />
                    }
                    <button title="facebook"
                            className="ba-default-btn referral-btn referral-facebook"
                            onClick={this.onShareClick.bind(this, this.getFbShareUrl())}>
                      <i className="fa fa-facebook-official" aria-hidden="true" />
                    </button>
                    <button title="twitter"
                            className="ba-default-btn referral-btn referral-twitter"
                            onClick={this.onShareClick.bind(this,
                              this.getTwitterShareUrl(), 'twitter')}>
                      <i className="fa fa-twitter" aria-hidden="true" />
                    </button>
                    <button title="share"
                            className="ba-default-btn referral-btn referral-linkedin"
                            onClick={this.onShareClick.bind(this, this.getLinkedinShareUrl())}>
                      <i className="fa fa-linkedin-square" aria-hidden="true" />
                    </button>
                    <button title="google plus"
                            className="ba-default-btn referral-btn referral-google-plus"
                            onClick={this.onShareClick.bind(this, this.getGooglePlusShareUrl())}>
                      <i className="fa fa-google-plus" aria-hidden="true" />
                    </button>
                    <button title="share"
                            className="ba-default-btn referral-btn referral-pinterest"
                            onClick={this.onShareClick.bind(this, this.getPinterestShareUrl())}
                            data-pin-do="buttonPin">
                      <i className="fa fa-pinterest" aria-hidden="true" />
                    </button>
                    <button title="share"
                            className="ba-default-btn referral-btn referral-tumblr"
                            onClick={this.onShareClick.bind(this, this.getTumblrShareUrl())}>
                      <i className="fa fa-tumblr" aria-hidden="true" />
                    </button>
                  </div>
                  {showEmail ?
                    <div>
                      <InputValidator fieldName="Email"
                                      shouldValidateOnBlur={true}
                                      className="referral-share-email">
                        <input type="email"
                               className="referral-share-email"
                               id="referral-share-email"
                               placeholder="enter friend's email address"
                               required
                               onChange={this.onChange.bind(this, 'email')}
                               value={this.state.email}/>
                      </InputValidator>
                      <button title="share"
                              className="ba-default-btn referral-btn-send success"
                              onClick={this.onShareClick.bind(this, this.getEmailShareUrl(), 'email')}>
                        Send Email
                      </button>
                    </div>
                    : null }
                </div>
              </div>

            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="ba-profile-info">
        <div className="row">
          <h2 className="ba-page-header">Personal Information</h2>
          {
            (isFetching || isSaving) ?
              <Loading />
              : null
          }
          {content}
        </div>
      </div>
    );
  }

  onShareClick(shareUrl) {
    ShareUtils.showShareWindow(shareUrl);
  }

  getPinterestShareUrl() {
    const shareImage = this.props.profile.avatar.fullSize;
    return ShareUtils.getPinterestShareUrl(this.refLink, shareImage, `Join me on ${_.get(settings, 'website.title')}! ${this.refLink}`);
  }

  getTwitterShareUrl() {
    const tweetText = `Join me on ${_.get(settings, 'website.title')}!`;
    return ShareUtils.getTwitterShareUrl(this.refLink, tweetText, _.get(settings, 'website.title'));
  }

  getFbShareUrl() {
    return ShareUtils.getFbShareUrl(this.refLink);
  }

  getGooglePlusShareUrl() {
    return ShareUtils.getGooglePlusShareUrl(this.refLink);
  }

  getLinkedinShareUrl() {
    const title = `${_.get(settings, 'website.title')} - Awesome Apps by TSL`;
    const summary = `Join me on ${_.get(settings, 'website.title')}!`;
    return ShareUtils.getLinkedinShareUrl(this.refLink, title, summary, this.url);
  }

  getTumblrShareUrl() {
    const title = `${_.get(settings, 'website.title')} - Awesome Apps by TSL`;
    const shareImage = this.props.profile.avatar.fullSize;
    return ShareUtils.getTumblrShareUrl(this.refLink, title, _.get(settings, 'website.title'), shareImage, `Join me on ${_.get(settings, 'website.title')}! ${this.refLink}`);
  }

  getEmailShareUrl() {
    let {email} = this.state;
    email = email || '';
    return ('mailto:' + email + '?subject=' + this.props.profile.firstName + ' ' + this.props.profile.lastName + ` has invited you to join ${_.get(settings, 'website.title')}!&body=Use my referral link to signup: ` + this.refLink);
  }
}

function mapStateToProps(state) {
  return {...state.profile};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

ProfileInfo.displayName = 'ProfileInfo';

ProfileInfo.propTypes = {
  onSave: PropTypes.func
};

ProfileInfo.contextTypes = {
  router: PropTypes.object.isRequired
};

ProfileInfo.defaultProps = {
  validateOnBlur: true
};

export default connect(mapStateToProps, mapDispatchToProps)(
  AuthenticatedPage(
    ValidatedComponent(
      ProfileInfo)
  )
);



// WEBPACK FOOTER //
// ./shared/profile/ProfileInfo.jsx